import $http from '$http'
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
export default {
    methods: {
        officalSumit(Params) {
            $http.post("api/School/ZqwPlatform_PassReportSchoolEx", Params).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: "成功",
                        message: "提交转正成功",
                        type: 'success'
                    });
                    this.dialogClose();
                    this.$emit("successcb")
                })
            })
        },
        // 审核
        CheckSchoolApply() {
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession
            }
            Params = Object.assign({}, this.submitform, Params);
            let $href = '/api/School/CheckSchoolApply'
            if (this.ApplyType == 0) {
                $href = '/api/School/CheckSchoolApply'
            } else if (this.ApplyType == 1) {
                $href = '/api/School/CheckSchoolCooperation'
            }
            $http.get($href, Params).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: "成功",
                        message: "审核成功",
                        type: "success"
                    });
                    this.dialogClose();
                    this.$emit("successcb")
                })
            })
        },
        // 正式幼儿园修改
        changeForm(Params) {

            $http.post("api/School/ZqwPlatform_ModifySchoolEx", Params).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: "成功",
                        message: "修改成功",
                        type: "success"
                    });
                    this.dialogClose();
                    this.$emit("successcb");
                });
            });

        },

        GetSchoolModel(Id, flag) {

            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                Id: Id
            };
            let $href = 'api/School/ZqwPlatform_GetSchoolModel'
            if (flag) {
                $href = 'api/School/GetSchoolContractById'
            }
            this.Myshort = []
            this.MyPolicy = []
            $http.get($href, Params).then(res => {
                let {
                    Data
                } = res.data;
                util.doResult(this, res, () => {
                    if (flag) {
                        this.submitform.TimeStamp = Data.TimeStamp
                    }
                    var a = Data.SchoolPics.split(",");
                    for (var i = 0; i < a.length; i++) {
                        if (a[i] == "") {
                            a.splice(i, 1)
                        } else {
                            var obj = {
                                Name: "",
                                Url: a[i]
                            };
                            this.SchoolPic.push(obj)
                        }
                    }
                    var b = Data.LicencePics.split(",");
                    for (var i = 0; i < b.length; i++) {
                        if (b[i] == "") {
                            b.splice(i, 1)
                        } else {
                            var obj = {
                                Name: "",
                                Url: b[i]
                            };
                            this.PermitPic.push(obj)
                        }
                    }
                    var c = Data.CooperationPics.split(",");
                    for (var i = 0; i < c.length; i++) {
                        if (c[i] == "") {
                            c.splice(i, 1)
                        } else {
                            var obj = {
                                Name: "",
                                Url: c[i]
                            };
                            this.contractPic.push(obj)
                        }
                    }
                    this.ApplyPicList = Data.ApplyPicList
                    var d = Data.EquipPics.split(",");
                    for (var i = 0; i < d.length; i++) {
                        if (d[i] == "") {
                            d.splice(i, 1)
                        } else {
                            var obj = {
                                Name: "",
                                Url: d[i]
                            };
                            this.equipmentPic.push(obj)
                        }
                    }

                    this.form = Object.assign({}, this.getFormData(), util.filterAndSetData(this.getFormData(), Data));
                    this.form.C_QQ = this.form.QQ
                    // 网络情况数据赋值
                    //console.log(Data.SchoolContract)
                    if (Data.SchoolContract !== null) {
                        this.SchoolContract.NetworkOperatorName = Data.SchoolContract.NetworkOperatorName.split(',')
                        this.SchoolContract.BandWidth = Data.SchoolContract.BandWidth
                        this.SchoolContract.IsSpecilLine = Data.SchoolContract.IsSpecilLine
                        this.SchoolContract.NetworkType = Data.SchoolContract.NetworkType.split(',')
                        this.SchoolContract.ProveType = Data.SchoolContract.ProveType
                        this.SchoolContract.ProvePics = cloneDeep(Data.SchoolContract.ProvePics)
                        this.SchoolContract.ContractPices = cloneDeep(Data.SchoolContract.ContractPices)
                        this.SchoolContract.DistanceName = Data.SchoolContract.DistanceName
                        this.SchoolContract.EngineerName = Data.SchoolContract.EngineerName
                        //console.log(this.SchoolContract.ProvePics)
                    }


                    if (this.form.Consignee == "") {
                        this.form.Consignee = this.form.PrincipalName
                    }
                    if (this.form.ConsigneeTel == "") {
                        let ConsigneeTel = this.form.PhoneNo
                        this.form.ConsigneeTel = ConsigneeTel.toString();
                    }
                    if (this.form.ConsigneeAdress == "") {
                        this.form.ConsigneeAdress = this.form.Address
                    }
                    if (!this.settings.Audit) {
                        // 修改传的是SchoolId
                        this.form.Id = Data.SchoolId;
                    } else {
                        // 审核传的是Id
                        this.form.Id = this.settings.id
                    }

                    this.form.hnc_drawing = Data.SchoolPics;
                    this.form.hndbond_drawing = Data.LicencePics;
                    this.form.hnd_CooperationPics = Data.CooperationPics;
                    this.form.hnd_EquipPics = Data.EquipPics;
                    this.SchoolStatus = Data.SchoolStatusName;
                    this.form.SchoolPhoneNo = Data.Tel
                    if (Data.ConsigneeProvince == '0' && Data.ConsigneeCity == '0') {
                        this.areaInfo = $.extend({}, this.getAreaData(), {
                            Provinces_Id: Data.Provinces_id,
                            City_Id: Data.City_id,
                            Area_Id: Data.Area_id
                        });
                    } else {
                        this.areaInfo = $.extend({}, this.getAreaData(), {
                            Provinces_Id: Data.ConsigneeProvince,
                            City_Id: Data.ConsigneeCity,
                            Area_Id: Data.ConsigneeArea
                        });
                    }

                    if (Data.ProjectTypes !== "") {
                        this.ProjectType = [];
                        let a = Data.ProjectTypes.toString().split(",");
                        a.forEach((item, index) => {
                            this.ProjectType.push(Number(item))
                        })

                    }
                    this.changeProjectType(this.ProjectType)



                    if (Data.PolicyTypes !== "") {
                        this.PolicyType = [];
                        let a = Data.PolicyTypes.toString().split(",");
                        a.forEach((item, index) => {
                            this.PolicyType.push(Number(item))
                        })

                    }




                    this.areaInfo2 = $.extend({}, this.getAreaData(), {
                        Provinces_Id: Data.Provinces_id,
                        City_Id: Data.City_id,
                        Area_Id: Data.Area_id
                    });
                    console.log(this.areaInfo2)
                    this.contactList = Data.ContactList;
                    this.form.C_name = this.contactList[0].C_name
                    this.form.C_email = this.contactList[0].C_email
                    this.form.C_tel = this.contactList[0].C_tel
                    this.form.C_weixin = this.contactList[0].C_weixin
                    if (this.settings.official) {
                        this.cloneServercontactList = Data.ContactList;
                        this.contactList = []

                    } else {
                        this.contactList.splice(0, 1)
                    }
                    this.$nextTick(function () {
                        this.flagStatus = false;
                    })

                });



            })
        },
        req_getProjectType(callback) {
            if (this.form.AgentId !== "") {
                let params = {
                    Sid: this.$store.state.sysSid,
                    Session: this.$store.state.sysSession,
                    AgentId: this.form.AgentId
                }
                let proId = [];
                $http.get("api/School/GetProjectByAgentId", params).then(res => {
                    util.doResult(this, res, () => {
                        this.SubjectList = res.data.Data;
                        for (let i = 0; i < this.SubjectList.length; i++) {
                            for (let j = 0; j < this.Myshort.length; j++) {
                                if (this.SubjectList[i].ProjectTypeId == this.Myshort[j]) {
                                    proId.push(this.Myshort[j])
                                }
                            }
                        }
                        //this.ProjectType = proId;
                        //console.log(this.ProjectType)
                        if (typeof callback == "function") {
                            callback();
                        }
                    });

                });
            }
        },
        // req_getProjectType2(callback) {
        //     let params = {
        //         Sid: this.$store.state.sysSid,
        //         Session: this.$store.state.sysSession,
        //         AgentId: this.form.AgentId
        //     }
        //     $http.get("api/School/GetPolicyTypeByAgentIdEx", params).then(res => {
        //         util.doResult(this, res, () => {
        //             this.PolicyList = res.data.Data;
        //             this.PolicyType = this.MyPolicy;
        //             if (typeof callback == "function") {
        //                 callback();
        //             }
        //         });

        //     });
        // },
        req_getPolicy(AgentProjectType) {

            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                AgentId: this.form.AgentId,
                AgentProjectType: AgentProjectType
            }
            $http.get("api/School/GetPolicyTypeByAgentIdEx", params).then(res => {
                util.doResult(this, res, () => {
                    this.PolicyList = res.data.Data;
                    // this.PolicyType = this.MyPolicy;
                    // if (typeof callback == "function") {
                    //     callback();
                    // }
                });

            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/school/components/official/services.js